export const Settings = {
  natural_code: {
    table: {
      title: 'Liste des codes Nature',
      btn_grp_account: 'Groupe de codes nature',
      columns: {
        code: 'Code',
        name: 'Nom',
        exo: 'Exo',
        sense: 'Sens',
        category: 'Catégorie',
        update_timestamp: 'Date Modification',
      },
    },
    fiche: {
      title: {
        edit_title: 'Fiche du Code Nature {{code}}',
        new_title: "Création d'un nouveau Code Nature",
        organization: 'Organisation',
      },
      champ_titles: {
        type: 'Type',
        code: 'Code',
        name: 'Nom',
        sense: 'Sens',
        level: 'Niveau',
        grouping: 'Regroupement',
        order: 'ordre',
        category: 'Catégorie',
        exo: 'Exonéré de commission de mouvement',
      },
    },
    groupe_code_nature: {
      title: 'Groupes de codes nature',
      title_modal_membre: 'Sélection groupe codes nature',
      sens: 'Sens',
      champs: {
        code: 'Code',
        name: 'Nom',
        date_create: 'Date création',
        comment: 'Commentaire',
        title_fiche: 'Fiche du groupe de codes nature {{code}}',
      },
    },
  },
  account_group: {
    table: {
      title: 'Liste des Groupes de Compte',
      error_devise:
        'Vous avez sélectionné des lignes contenant des devises différentes',
      columns: {
        code: 'Code',
        name: 'Nom',
        state: 'Etat',
        update_timestamp: 'Date Modification',
      },
      buttons: {
        type_new: 'Nouveau Type',
      },
    },
    fiche: {
      title: {
        edit_title: 'Fiche du Groupe de Comptes {{code}}',
        new_title: "Création d'un nouveau Groupe de Comptes",
        new_title_type: "Création d'un nouveau Type de Groupe de Comptes",
        member: 'Liste des membres',
        nb_selected: '(Nombre de membre séléctionné : {{nb}})',
        nbs_selected: '(Nombre de membres séléctionnés : {{nb}})',
        edit_type_title:
          "Modification d'une fiche de type de groupe de comptes - {{code}}",
      },
      champ_titles: {
        type: 'Type',
        code: 'Code',
        name: 'Nom',
        cashpool_level: 'Niveau de cashpooling',
        description: 'Description',
        state: 'Etat',
        sub_type: 'Sous-type',
        devise: "Devise de l'autorisation de decouvert",
        group_decouvert: 'Autorisation de découvert du groupe',
        add_decouvert: 'Montant',
        title_modal_add_decouvert: 'Ajout autorisation de découvert ',
        generation_mode: 'Mode de génération',
      },
      buttons: {
        add_account_group: 'Ajouter un groupe de compte',
      },
      columns: {
        code: 'Code',
        name: 'Nom',
        state: 'Etat',
        code_name: 'Code-Nom',
        iban: 'IBAN',
        company: 'Société',
        rounding: 'Arrondi',
        currency: 'Devise',
        amount: 'Solde cible',
        pivot: 'Pivot',
        member_decouvert: 'Autorisation de découvert',
      },
    },
    modal: {
      title: {
        account: 'Sélection de comptes bancaires',
        account_group: 'Sélection de groupe de comptes',
        update: 'Modification du groupe de compte',
      },
      choice: {
        nope: 'Non',
        yes: 'Oui',
      },
      buttons: {
        add: 'Ajouter',
        close: 'Annuler',
      },
      champ_titles: {
        pivot: 'Pivot',
        amount: 'Seuil',
        arounding: 'Arrondi',
      },
    },
  },
  reports: {
    table: {
      title: 'Liste des Etats de trésorerie',
      columns: {
        code: 'Code',
        name: 'Nom',
        update_timestamp: 'Date Modification',
      },
    },
    fiche: {
      title: {
        edit_title: "Fiche de l'état tréso {{code}}",
        new_title: "Création d'un nouvel Etat",
        member: 'Liste des membres',
        fiche: 'Caractéristiques',
        fiche_zoom: 'Caractéristique Zoom',
        diffusion: 'Diffusion',
      },
      champ_titles: {
        type: 'Type',
        code: 'Code',
        name: 'Nom',
        selection: 'Selection',
        period_type: 'Type Période',
        period: 'Période',
        unit: 'Unité',
        forecast: 'Prévision',
        category: 'Catégorie',
        nature: 'Nature',
        min_amount: 'Montant Min',
        max_amount: 'Montant Max',
        label: 'Libelle',
        mode: 'Mode',
        mail_adress: 'Adresses emails',
        user_smart_tag: 'Smart Tags utilisateurs',
        user_groupsmart_tag: "Smart Tags groupe d'utilisateur",
        detail: 'Détail',
        ecart: 'Ecart',
        elem: 'Elément',
      },
      columns: {
        code: 'Code',
        name: 'Nom',
      },
    },
    modal: {
      title: 'Sélection de membres',
      buttons: {
        add: 'Ajouter',
        close: 'Annuler',
      },
    },
  },
  treasury_rules: {
    table: {
      title: 'Liste des Règles de trésorerie',
      columns: {
        code: 'Code',
        name: 'Nom',
        auto: 'Auto/Manuel',
        ordre: 'Ordre',
        update_timestamp: 'Date Modification',
        state: 'Etat',
        category: 'Catégorie',
        releve: 'Sur Relevé',
        prevision: 'Sur Prevision',
        flux: 'Sur Flux',
      },
    },
    fiche: {
      title: {
        edit_title: 'Fiche du Règle trésorerie {{code}}',
        new_title: "Création d'un nouveau Groupe de Comptes",
        new_title_type: "Création d'un nouveau Type de Groupe de Comptes",
        new_rule_title: "Création d'une nouvelle Règle",
        member: 'Liste des membres',
        criteria_reconciliation: 'Critères Rapprochement',
        member_selection: 'Sélectionner de membres',
      },
      champ_titles: {
        type: 'Type',
        code: 'Code',
        name: 'Nom',
        category: 'Catégorie',
        selection: 'Sélection',
        mode: 'Mode',
        execution_order: "Ordre d'exécution",
        cashpool_level: 'Niveau de cashpooling',
        description: 'Description',
        state: 'Etat',
        deviation_allowed: 'Ecart autorisé',
        rappro_number: 'Rapprochement par Numéro de pièce',
        ecart_autorise: 'Ecart autorisé',
        nature: 'Nature',
        libelle: 'Libellé',
        placeholder_category: 'Saisir le Code Catégorie',
        placeholder_selection: '- Sélection -',
        placeholder_gap: 'Ecart sur montant autorisé',
        placeholder_rule_code: 'Code de la règle',
        placeholder_rule_name: 'Nom de la règle',
        placeholder_montant_autorise: 'Ecart sur montant autorisé',
        placeholder_libelle: 'Contient le libellé',
        applique_releve: 'A appliquer sur les relevés',
        applique_temporaire: 'A appliquer sur les prévisions temporaires',
        applique_flux: 'A appliquer sur les flux',
        flux: 'Flux',
        ventilation: 'Critères Ventilation',
      },
    },
  },
  etablish_externe: {
    table: {
      title: 'Liste des établissement externes',
      button_account_title: 'Comptes bancaires',
      columns: {
        etablish_name: 'Etablissement',
      },
    },
    fiche: {
      title: "Création d'un nouvel établissement externe",
      titleEdit: "Fiche de l'établissement externe {{name}}",
    },
  },

  etablish_externe_compte: {
    table: {
      title: 'Liste des comptes bancaires des établissements externes',
      columns: {
        etablish_name: 'Etablissement',
      },
    },
    fiche: {
      title: "Création d'un nouveau compte externe",
      titleEdit: 'Fiche du compte {{name}}',
    },
  },
}

